const modelList = (state = {}, action) => {
    switch (action.type) {
        case 'SET_LIST_OF_MODELS':
            return {
                ...state,
                modelList: action.payload
            };
        default:
            return state;
    }
};
export default modelList;
